"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.flat.js");
require("core-js/modules/es.array.unscopables.flat.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.slice.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("@citrus/button");
var _icon = require("@citrus/icon");
var _badge = require("@citrus/badge");
var _inputSelect = require("@citrus/input-select");
var _inputTextfield = require("@citrus/input-textfield");
var _callout = require("@citrus/callout");
var _layout = require("@citrus/layout");
var _modal = require("@citrus/modal");
var _zeroState = require("@citrus/zero-state");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _dragNDrop = require("@citrus/drag-n-drop");
var _findIndexes = _interopRequireDefault(require("@pcty/utils-commonjs/array/findIndexes"));
var _insertAt = _interopRequireDefault(require("@pcty/utils-commonjs/array/insertAt"));
var _removeAt = _interopRequireDefault(require("@pcty/utils-commonjs/array/removeAt"));
var _replaceAt = _interopRequireDefault(require("@pcty/utils-commonjs/array/replaceAt"));
var _capitalize = _interopRequireDefault(require("@pcty/utils-commonjs/string/capitalize"));
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _isNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNullOrEmpty"));
var _reactDragula = _interopRequireDefault(require("react-dragula"));
var _lodash = _interopRequireDefault(require("lodash.findindex"));
var _lodash2 = _interopRequireDefault(require("lodash.isequal"));
var _lodash3 = _interopRequireDefault(require("lodash.groupby"));
var _uuid = _interopRequireDefault(require("uuid"));
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.Drawer"));
var _PctyQuestionBuilderEdit2 = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.PageManager"));
var _PctyQuestionBuilderQuestionBank = _interopRequireDefault(require("./PctyQuestionBuilder.QuestionBank.Drawer"));
var _PctyQuestionBuilder2 = _interopRequireDefault(require("./PctyQuestionBuilder.Checkbox"));
var _PctyQuestionBuilder3 = _interopRequireDefault(require("./PctyQuestionBuilder.MultipleChoice"));
var _PctyQuestionBuilder4 = _interopRequireDefault(require("./PctyQuestionBuilder.TrueFalse"));
var _PctyQuestionBuilder5 = _interopRequireDefault(require("./PctyQuestionBuilder.StackRank"));
var _PctyQuestionBuilder6 = _interopRequireDefault(require("./PctyQuestionBuilder.SectionTitle"));
var _PctyQuestionBuilder7 = _interopRequireDefault(require("./PctyQuestionBuilder.SectionParagraph"));
var _PctyQuestionBuilder8 = _interopRequireDefault(require("./PctyQuestionBuilder.Video"));
var _PctyQuestionBuilder9 = _interopRequireDefault(require("./PctyQuestionBuilder.TextField"));
var _PctyQuestionBuilder10 = _interopRequireDefault(require("./PctyQuestionBuilder.StarRating"));
var _PctyQuestionBuilder11 = _interopRequireDefault(require("./PctyQuestionBuilder.RatingScale"));
var _PctyQuestionBuilder12 = _interopRequireDefault(require("./PctyQuestionBuilder.MultipleText"));
var _PctyQuestionBuilder13 = _interopRequireDefault(require("./PctyQuestionBuilder.ConstantSum"));
var _PctyQuestionBuilder14 = _interopRequireDefault(require("./PctyQuestionBuilder.DropdownList"));
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilder15 = require("./PctyQuestionBuilder.Constants");
var _quizBuilderDrag = _interopRequireDefault(require("./quiz-builder-drag.png"));
require("./index.css");
var _p, _p2, _Badge, _Badge2, _Badge3, _Icon, _Icon2, _Icon3, _Icon4, _Icon5, _Icon6, _div;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctyQuestionBuilder = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionBuilder, _Component);
  var _super = _createSuper(PctyQuestionBuilder);
  function PctyQuestionBuilder(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionBuilder);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "deselectActiveQuestion", function (e) {
      // if there's an active question, check if the user clicked inside it and exit
      if ((0, _isNotNullOrEmpty.default)(_this.state.activeQuestionId)) {
        var node = document.getElementById(_this.state.activeQuestionId);
        if (node && e && node.contains(e.target)) {
          return;
        }
      }

      // if the drawer isn't open and we made it this far, clear the active question
      var drawerOpen = !!_this.state.edit;
      if (!drawerOpen) {
        _this.setState({
          activeQuestionId: null
        });
      }
    });
    _this.dragFromId = 'drag-from';
    _this.dragTargetId = 'pcty-question-builder-drop-target';
    var selectedCategoryType = props.categoryTypeOptions.filter(function (x) {
      return x.selected === true;
    });
    var pages = getPages(props.questions, props.configOptions.enablePageManager);
    _this.state = {
      drawerContext: 'new',
      activeDrawerTab: null,
      edit: null,
      editQuestionNumber: -1,
      activeQuestionId: null,
      categoryType: (0, _isNotNullOrEmpty.default)(selectedCategoryType) ? selectedCategoryType[0] : {
        value: '',
        text: ''
      },
      pages: pages,
      activePageIndex: 0,
      activeQuestionHasConditionalRefs: false,
      deleteModal: {
        open: false,
        id: null
      },
      showQuestionBank: false
    };
    _this.onDrop = _this.onDrop.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickSaveEditing = _this.onClickSaveEditing.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickCancelEditing = _this.onClickCancelEditing.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOnChangeName = _this.handleOnChangeName.bind((0, _assertThisInitialized2.default)(_this));
    _this.onQuestionUpdated = _this.onQuestionUpdated.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickCopy = _this.onClickCopy.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickRequired = _this.onClickRequired.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickHasOtherField = _this.onClickHasOtherField.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickEdit = _this.onClickEdit.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickConfirmRemove = _this.onClickConfirmRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.onVideoDoneHandler = _this.onVideoDoneHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickRemove = _this.onClickRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancelRemove = _this.onCancelRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSingleClick = _this.onSingleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOnChangeCategoryType = _this.handleOnChangeCategoryType.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSetActiveQuestion = _this.onSetActiveQuestion.bind((0, _assertThisInitialized2.default)(_this));
    _this.onShowQuestionBank = _this.onShowQuestionBank.bind((0, _assertThisInitialized2.default)(_this));
    _this.onAddQuestionsFromQuestionBank = _this.onAddQuestionsFromQuestionBank.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancelQuestionBank = _this.onCancelQuestionBank.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionBuilder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      document.addEventListener('click', this.deselectActiveQuestion, true);
      var dragulaConfig = {
        accepts: function accepts(el, target, source /* , sibling */) {
          return target.id === _this2.dragFromId && source === target || target.id === _this2.dragTargetId;
        },
        copy: function copy(el) {
          return !(el.classList.contains('pcty-draggable-item-content') || el.classList.contains('citron-draggable-item-content'));
        },
        copySortSource: false,
        moves: function moves(el) {
          return !(el.classList.contains('pcty-disabled') || el.classList.contains('pcty-undraggable') || el.classList.contains('citron-undraggable'));
        },
        revertOnSpill: true
      };
      (0, _reactDragula.default)([document.getElementById(this.dragFromId), document.getElementById(this.dragTargetId)], dragulaConfig).on('drop', this.onDrop);
      document.addEventListener('touchmove', this.preventBehavior, {
        passive: false
      });
    }
  }, {
    key: "preventBehavior",
    value: function preventBehavior(e) {
      if (e.target.classList.contains('pcty-draggable-item')) {
        e.preventDefault();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash2.default)(this.props.questions, nextProps.questions) || nextProps.questions && nextProps.questions.length === 0) {
        var selectedCategoryType = nextProps.categoryTypeOptions.filter(function (x) {
          return x.selected === true;
        });
        var newState = {
          drawerContext: 'new',
          activeDrawerTab: null,
          activeQuestionId: null,
          categoryType: (0, _isNotNullOrEmpty.default)(selectedCategoryType) ? selectedCategoryType[0] : {
            value: '',
            text: ''
          },
          activeQuestionHasConditionalRefs: false,
          deleteModal: {
            open: false,
            id: null
          }
        };

        // reset the pages for new surveys
        if (nextProps.questions.length === 0) {
          newState.pages = getPages(nextProps.questions, this.props.configOptions.enablePageManager);
          newState.activePageIndex = 0;
        }
        this.setState(_objectSpread({}, newState));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.deselectActiveQuestion, true);
      document.removeEventListener('touchmove', this.preventBehavior, true);
    }
  }, {
    key: "onSingleClick",
    value: function onSingleClick(type) {
      // prevent action if active question is invalid
      var activeQuestionValid = this.isActiveQuestionValid();
      if (!activeQuestionValid) return;

      // new item
      var item = transformDroppedItem({
        id: type,
        required: this.props.configOptions.setDefaultRequired !== undefined ? this.props.configOptions.setDefaultRequired : true,
        page: this.state.pages[this.state.activePageIndex]
      });
      var flattenedQuestions = this.props.questions.flat();
      var newQuestionIndex = this.getNextQuestionIndex(flattenedQuestions);
      var questions = newQuestionIndex >= flattenedQuestions.length ? [].concat((0, _toConsumableArray2.default)(flattenedQuestions), [item]) : (0, _insertAt.default)(flattenedQuestions, newQuestionIndex, item);
      this.handleOnChangeQuestionsWithPages(questions);
      this.startItemEditing(item, 'new', newQuestionIndex);
      this.props.onDrop();
    }
  }, {
    key: "onDrop",
    value: function onDrop(el, target, source, sibling) {
      // Only allow one way dragging and sorting.
      if (!target || target.id === this.dragFromId) {
        return;
      }
      var flattenedQuestions = this.props.questions.flat();
      if (target.id === source.id) {
        // reorder
        var originalIndex = (0, _lodash.default)(flattenedQuestions, function (x) {
          return x.id === el.id;
        });
        var item = _objectSpread({}, flattenedQuestions[originalIndex]);
        var updatedQuestions = (0, _removeAt.default)(flattenedQuestions, originalIndex);
        var newQuestionIndex = this.getNextQuestionIndex(updatedQuestions, sibling);
        if (newQuestionIndex === 0) {
          updatedQuestions = [item].concat((0, _toConsumableArray2.default)(updatedQuestions));
        } else if (newQuestionIndex >= updatedQuestions.length) {
          updatedQuestions = [].concat((0, _toConsumableArray2.default)(updatedQuestions), [item]);
        } else {
          updatedQuestions = (0, _insertAt.default)(updatedQuestions, newQuestionIndex, item);
        }
        this.handleOnChangeQuestionsWithPages(updatedQuestions);
      } else {
        // new item
        var _item = transformDroppedItem({
          id: el.id,
          required: this.props.configOptions.setDefaultRequired !== undefined ? this.props.configOptions.setDefaultRequired : true,
          page: this.state.pages[this.state.activePageIndex]
        });
        var _newQuestionIndex = this.getNextQuestionIndex(flattenedQuestions, sibling);
        var questions = _newQuestionIndex >= flattenedQuestions.length ? [].concat((0, _toConsumableArray2.default)(flattenedQuestions), [_item]) : (0, _insertAt.default)(flattenedQuestions, _newQuestionIndex, _item);
        this.handleOnChangeQuestionsWithPages(questions);
        this.startItemEditing(_item, 'new', _newQuestionIndex + 1);
        this.props.onDrop();
        if (el.parentNode) el.parentNode.removeChild(el);
      }
    }
  }, {
    key: "getNextQuestionIndex",
    value: function getNextQuestionIndex(flattenedQuestions, sibling) {
      var _this3 = this;
      var newQuestionIndex = 0;
      if (sibling) {
        var siblingIndex = (0, _lodash.default)(flattenedQuestions, function (x) {
          return x.id === sibling.id;
        });
        newQuestionIndex = siblingIndex >= 0 ? siblingIndex : flattenedQuestions.length;
      } else {
        if ((0, _isNotNullOrEmpty.default)(flattenedQuestions) && (0, _isNotNullOrEmpty.default)(this.state.activeQuestionId)) {
          newQuestionIndex = flattenedQuestions.findIndex(function (x) {
            return x.id === _this3.state.activeQuestionId;
          }) + 1;
        } else {
          if (this.props.configOptions.enablePageManager && this.state.pages.length > 0) {
            // put the new question at the end of the current page
            var questionPageCounts = 0;
            this.state.pages.map(function (page, index) {
              var pageElements = flattenedQuestions.filter(function (x) {
                return x.pageId === page.key;
              });
              if (index < _this3.state.activePageIndex) {
                questionPageCounts += pageElements.length;
              } else if (index === _this3.state.activePageIndex) {
                newQuestionIndex = pageElements.length + questionPageCounts;
                return;
              } else {
                return;
              }
            });
          } else {
            newQuestionIndex = flattenedQuestions.length;
          }
        }
      }
      return newQuestionIndex;
    }
  }, {
    key: "isActiveQuestionValid",
    value: function isActiveQuestionValid() {
      var _this4 = this;
      if ((0, _isNullOrEmpty.default)(this.state.activeQuestionId)) return true;
      var flattenedQuestions = this.props.questions.flat();
      var questionIndex = flattenedQuestions.findIndex(function (x) {
        return x.id === _this4.state.activeQuestionId;
      });
      if (questionIndex < 0) return true;
      var question = flattenedQuestions[questionIndex];
      var validationState = question.validationState ? question.validationState : (0, _PctyQuestionBuilder.validate)(question, true, this.props.builderType);
      return validationState.valid;
    }
  }, {
    key: "onSetActiveQuestion",
    value: function onSetActiveQuestion(item) {
      var validateActiveQuestion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // check if previous question is valid and prevent switching if not!
      if (item && validateActiveQuestion) {
        // prevent action if active question is invalid
        var activeQuestionValid = this.isActiveQuestionValid();
        if (!activeQuestionValid) return;
      }
      var id = item ? item.id : null;
      this.setState({
        activeQuestionId: id
      });
    }
  }, {
    key: "startItemEditing",
    value: function startItemEditing(item, drawerContext, questionNumber) {
      // set this one to be active
      this.onSetActiveQuestion(item, false);
      this.setState({
        edit: item,
        drawerContext: drawerContext,
        activeDrawerTab: null,
        editQuestionNumber: questionNumber
      });
    }
  }, {
    key: "endItemEditing",
    value: function endItemEditing() {
      this.setState({
        edit: null,
        drawerContext: 'new',
        activeDrawerTab: null
      });
    }
  }, {
    key: "onQuestionUpdated",
    value: function onQuestionUpdated(id, updates) {
      var questions = this.props.questions.flat();
      var index = (0, _lodash.default)(questions, function (x) {
        return x.id === id;
      });
      if (index < 0) {
        return;
      }
      var item = questions[index];
      if (updates) {
        // update the text and options if specified; sometimes the updates don't have it!
        item.question = updates.hasOwnProperty('questionText') ? (0, _PctyQuestionBuilder.decodeText)(updates.questionText) : (0, _PctyQuestionBuilder.decodeText)(item.question);
        item.options = updates.hasOwnProperty('options') ? (0, _toConsumableArray2.default)(updates.options) : item.options;

        // updates to specific questiontype props
        if (item.typeId === _questionBuilder.QUESTION_TYPE.title) {
          item.title = updates.hasOwnProperty('questionText') ? (0, _PctyQuestionBuilder.decodeText)((0, _PctyQuestionBuilder.removeHtmlTags)(updates.questionText)) : (0, _PctyQuestionBuilder.decodeText)(item.title);
          item.includeSectionHeading = updates.hasOwnProperty('includeSectionHeading') ? updates.includeSectionHeading : item.includeSectionHeading;
        } else if (item.typeId === _questionBuilder.QUESTION_TYPE.paragraph) {
          item.content = updates.hasOwnProperty('questionText') ? (0, _PctyQuestionBuilder.decodeText)(updates.questionText) : (0, _PctyQuestionBuilder.decodeText)(item.content);
        } else if (item.typeId === _questionBuilder.QUESTION_TYPE.video) {
          item.title = updates.hasOwnProperty('questionText') ? (0, _PctyQuestionBuilder.decodeText)(updates.questionText) : (0, _PctyQuestionBuilder.decodeText)(item.title);
        } else if (item.typeId === _questionBuilder.QUESTION_TYPE.textField) {
          item.questionPlaceholder = updates.hasOwnProperty('questionPlaceholder') ? (0, _PctyQuestionBuilder.decodeText)(updates.questionPlaceholder) : (0, _PctyQuestionBuilder.decodeText)(item.questionPlaceholder);
          item.multiLine = updates.hasOwnProperty('multiLine') ? updates.multiLine : item.multiLine;
        } else if (item.typeId === _questionBuilder.QUESTION_TYPE.starRating) {
          item.starCount = updates.hasOwnProperty('starCount') ? updates.starCount : item.starCount;
        } else if (item.typeId === _questionBuilder.QUESTION_TYPE.ratingScale) {
          item.minimumRateLabel = updates.hasOwnProperty('minimumRateLabel') ? (0, _PctyQuestionBuilder.decodeText)(updates.minimumRateLabel) : (0, _PctyQuestionBuilder.decodeText)(item.minimumRateLabel);
          item.maximumRateLabel = updates.hasOwnProperty('maximumRateLabel') ? (0, _PctyQuestionBuilder.decodeText)(updates.maximumRateLabel) : (0, _PctyQuestionBuilder.decodeText)(item.maximumRateLabel);
        }
        if (this.props.questionCommentsEnabled) {
          item.allowComments = updates.hasOwnProperty('allowComments') ? updates.allowComments : item.allowComments;
          item.commentsPlaceholder = updates.hasOwnProperty('commentsPlaceholder') ? (0, _PctyQuestionBuilder.decodeText)(updates.commentsPlaceholder) : (0, _PctyQuestionBuilder.decodeText)(item.commentsPlaceholder);
        }
      }
      var drawerOpen = !!this.state.edit;
      if (!drawerOpen) {
        var validationState = (0, _PctyQuestionBuilder.validate)(item, true, this.props.builderType);
        item.validationState = _objectSpread({}, validationState);
      }
      var retQuestions = (0, _replaceAt.default)(questions, index, item);
      this.handleOnChangeQuestionsWithPages(retQuestions);
    }
  }, {
    key: "onClickCopy",
    value: function onClickCopy(item, number) {
      var questions = this.props.questions.flat();
      var copiedItem = this.copyQuestion(item);
      var index = (0, _lodash.default)(questions, function (x) {
        return x.id === item.id;
      });
      questions.splice(index + 1, 0, copiedItem);
      this.handleOnChangeQuestionsWithPages(questions);
    }
  }, {
    key: "onClickRequired",
    value: function onClickRequired(item, number) {
      var questions = this.props.questions.flat();
      var index = (0, _lodash.default)(questions, function (x) {
        return x.id === item.id;
      });
      if (index < 0) {
        this.endItemEditing();
        return;
      }
      item.answerRequired = !item.answerRequired;
      var retQuestions = (0, _replaceAt.default)(questions, index, item);
      this.handleOnChangeQuestionsWithPages(retQuestions);
    }
  }, {
    key: "onClickHasOtherField",
    value: function onClickHasOtherField(item, number) {
      var questions = this.props.questions.flat();
      var index = (0, _lodash.default)(questions, function (x) {
        return x.id === item.id;
      });
      if (index < 0) {
        this.endItemEditing();
        return;
      }
      item.otherQuestion.enabled = !item.otherQuestion.enabled;
      var retQuestions = (0, _replaceAt.default)(questions, index, item);
      this.handleOnChangeQuestionsWithPages(retQuestions);
    }
  }, {
    key: "onClickEdit",
    value: function onClickEdit(item, number, activeDrawerTab) {
      this.setState({
        edit: item,
        drawerContext: 'edit',
        activeDrawerTab: activeDrawerTab,
        editQuestionNumber: number
      });
    }
  }, {
    key: "onClickSaveEditing",
    value: function onClickSaveEditing(edit) {
      var questions = this.props.questions.flat();
      var index = (0, _lodash.default)(questions, function (x) {
        return x.id === edit.id;
      });
      if (index < 0) {
        this.endItemEditing();
        return;
      }
      edit.key = _uuid.default.v4();
      var validationState = (0, _PctyQuestionBuilder.validate)(edit, true, this.props.builderType);
      edit.validationState = _objectSpread({}, validationState);
      var retQuestions = (0, _replaceAt.default)(questions, index, edit);
      this.handleOnChangeQuestionsWithPages(retQuestions);
      this.endItemEditing();
    }
  }, {
    key: "onClickCancelEditing",
    value: function onClickCancelEditing() {
      this.endItemEditing();
    }
  }, {
    key: "onCancelRemove",
    value: function onCancelRemove() {
      this.setState({
        deleteModal: {
          open: false,
          id: null
        }
      });
    }
  }, {
    key: "onShowQuestionBank",
    value: function onShowQuestionBank() {
      this.setState({
        showQuestionBank: true
      });
    }
  }, {
    key: "onCancelQuestionBank",
    value: function onCancelQuestionBank() {
      this.setState({
        showQuestionBank: false
      });
    }
  }, {
    key: "onAddQuestionsFromQuestionBank",
    value: function onAddQuestionsFromQuestionBank(newQuestions) {
      // set the newQuestions pageId and source flag
      var activePageId = this.state.pages.length > 0 && this.state.pages[this.state.activePageIndex] ? this.state.pages[this.state.activePageIndex].key : this.state.pages[0].key;
      newQuestions = newQuestions.map(function (q) {
        q.pageId = activePageId;
        q.fromQuestionBank = true;
        return q;
      });

      // splice the new questions in
      var questions = this.props.questions.flat();
      questions = [].concat((0, _toConsumableArray2.default)(questions), (0, _toConsumableArray2.default)(newQuestions));
      this.handleOnChangeQuestionsWithPages(questions);
      this.setState({
        showQuestionBank: false
      });
    }
  }, {
    key: "questionHasConditionalReferences",
    value: function questionHasConditionalReferences(id) {
      var hasRefs = false;
      var questions = this.props.questions.flat();
      var refs = questions.filter(function (x) {
        return x.visibleIf && x.visibleIf.length > 0 && x.visibleIf.indexOf(id) > -1;
      });
      hasRefs = refs.length > 0;
      return hasRefs;
    }
  }, {
    key: "onClickRemove",
    value: function onClickRemove(item) {
      var activeQuestionHasConditionalRefs = this.props.configOptions.enableConditionalQuestions && this.questionHasConditionalReferences(item.id);
      this.setState({
        deleteModal: {
          open: true,
          id: item.id
        },
        activeQuestionHasConditionalRefs: activeQuestionHasConditionalRefs
      });
    }
  }, {
    key: "onClickConfirmRemove",
    value: function onClickConfirmRemove(id) {
      // remove the question by simply filtering it out
      var retQuestions = this.props.questions.flat().filter(function (x) {
        return x.id !== id;
      });

      // clear out the conditional statements for ALL questions referencing this id!
      if (this.questionHasConditionalReferences(id)) {
        // make a deep-copy
        var questions = (0, _toConsumableArray2.default)(retQuestions);
        // cannot clear out just the invalid clause because it may invalid the conditional logic!
        questions.map(function (question, index) {
          if (question.visibleIf && question.visibleIf.length > 0 && question.visibleIf.indexOf(id) > -1) {
            question.visibleIf = '';
            retQuestions = (0, _replaceAt.default)(retQuestions, index, question);
          }
        });
      }
      this.handleOnChangeQuestionsWithPages(retQuestions);
      this.setState({
        edit: null,
        drawerContext: 'new',
        deleteModal: {
          open: false,
          id: null
        }
      });
    }
  }, {
    key: "onVideoDoneHandler",
    value: function onVideoDoneHandler(item, videoEvent) {
      var edit = _objectSpread(_objectSpread({}, item), {}, {
        videoId: videoEvent.videoId,
        filename: videoEvent.filename,
        videoInsertMethod: videoEvent.method,
        token: videoEvent.token,
        key: (0, _isNullOrEmpty.default)(videoEvent.videoId) ? _uuid.default.v4() : item.key
      });
      var questions = this.props.questions.flat();
      var index = (0, _lodash.default)(questions, function (x) {
        return x.id === edit.id;
      });
      var retQuestions = (0, _replaceAt.default)(questions, index, edit);
      this.handleOnChangeQuestionsWithPages(retQuestions);
    }
  }, {
    key: "handleOnChangeQuestionsWithPages",
    value: function handleOnChangeQuestionsWithPages(questions) {
      var retArr = this.handlePageConversion(questions);
      this.props.onChangeQuestions(retArr);
    }
  }, {
    key: "handlePageConversion",
    value: function handlePageConversion(questions) {
      var _this$props$configOpt = this.props.configOptions,
        questionsPerPage = _this$props$configOpt.questionsPerPage,
        enablePageManager = _this$props$configOpt.enablePageManager;
      var title = _questionBuilder.QUESTION_TYPE.title,
        paragraph = _questionBuilder.QUESTION_TYPE.paragraph,
        video = _questionBuilder.QUESTION_TYPE.video;
      var returnArr = [];
      if (enablePageManager == true) {
        // add a pageId to every question obj, then build up the arrays
        var pages = (0, _lodash3.default)(questions, 'pageId');
        if (pages) {
          Object.keys(pages).map(function (key) {
            returnArr.push(pages[key]);
          });
        } else {
          returnArr.push(questions);
        }
      } else {
        // ick - with new format, this returns an array of array questions: [[questions]]
        if (questionsPerPage === 0 || typeof questionsPerPage !== 'number') return [questions];
        var pageQuestionsArr = [];
        var questionCountPageTracker = 0;

        // legacy: check how many items per page to display and build up the pages->questions array/children accordingly
        questions.map(function (question, index) {
          // add this question to the current page array
          pageQuestionsArr.push(question);

          // if we hit the questionsPerPage limit, push the entire pageQuestionsArray into the retArray (each array is 1 page)
          if (questionCountPageTracker + 1 === questionsPerPage || index + 1 === questions.length) {
            returnArr.push(pageQuestionsArr);
            pageQuestionsArr = [];
            questionCountPageTracker = 0;
          }

          // inc the counter
          if (question.typeId !== title && question.typeId !== paragraph && question.typeId !== video) {
            questionCountPageTracker += 1;
          }
        });
      }
      return returnArr;
    }
  }, {
    key: "handleOnChangeName",
    value: function handleOnChangeName(_ref) {
      var value = _ref.value;
      var name = {
        value: value,
        validationState: _objectSpread(_objectSpread({}, this.props.name.validationState), {}, {
          valid: (0, _isNotNullOrEmpty.default)(value)
        })
      };
      this.props.onChangeName(name, this.props.questions.flat());
    }
  }, {
    key: "handleOnChangeCategoryType",
    value: function handleOnChangeCategoryType(selected) {
      var categoryType = {
        value: selected.value,
        text: selected.label
      };
      this.setState({
        categoryType: categoryType
      });
      var updatedCategoryType = {
        selected: selected,
        validationState: _objectSpread(_objectSpread({}, this.props.categoryType.validationState), {}, {
          valid: this.props.categoryTypeRequired ? (0, _isNotNullOrEmpty.default)(selected.value) : true
        })
      };
      this.props.onChangeCategoryType(updatedCategoryType);
    }
  }, {
    key: "getSideBarOptions",
    value: function getSideBarOptions() {
      var _this5 = this;
      var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var questionTypes = [_questionBuilder.QUESTION_TYPE.trueFalse, _questionBuilder.QUESTION_TYPE.stackRank, _questionBuilder.QUESTION_TYPE.multipleChoice];
      if (this.props.builderType === _PctyQuestionBuilder15.BUILDER_TYPE.survey) {
        questionTypes = [_questionBuilder.QUESTION_TYPE.title, _questionBuilder.QUESTION_TYPE.paragraph, _questionBuilder.QUESTION_TYPE.multipleChoice, _questionBuilder.QUESTION_TYPE.dropdownList, _questionBuilder.QUESTION_TYPE.textField, _questionBuilder.QUESTION_TYPE.starRating, _questionBuilder.QUESTION_TYPE.ratingScale, _questionBuilder.QUESTION_TYPE.stackRank, _questionBuilder.QUESTION_TYPE.multipleText, _questionBuilder.QUESTION_TYPE.constantSum];
        if (this.props.premiumVideoEnabled) {
          questionTypes.push(_questionBuilder.QUESTION_TYPE.video);
        }
      }
      var hasQuestions = this.props.questions.length > 0;
      return questionTypes.map(function (x) {
        var questionType = _PctyQuestionBuilder15.QUESTION_TYPES_LIST.find(function (qt) {
          return qt.questionTypeId === x;
        });
        return /*#__PURE__*/_react.default.createElement(_dragNDrop.DragNDrop.DraggableItem, {
          disabled: disabled && hasQuestions,
          id: questionType.questionTypeId.toString(),
          key: questionType.questionTypeId.toString(),
          onClick: function onClick() {
            return _this5.onSingleClick(questionType.questionTypeId);
          }
        }, questionType.label);
      });
    }
  }, {
    key: "getQuestionNumber",
    value: function getQuestionNumber(item, onlyQuestions) {
      var _this6 = this;
      var questionNumber = 1;
      if (onlyQuestions !== undefined && item !== undefined && onlyQuestions.length > 0) {
        // figure out the next number based upon prior pages
        if (this.props.configOptions.enablePageManager && this.state.pages.length > 0) {
          var questionPageCounts = 0;
          this.state.pages.map(function (page, index) {
            var pageElements = onlyQuestions.filter(function (x) {
              return x.pageId === page.key;
            });
            if (index < _this6.state.activePageIndex) {
              questionPageCounts += pageElements.length;
            } else if (index === _this6.state.activePageIndex) {
              questionNumber = pageElements.findIndex(function (question) {
                return question.id === item.id;
              }) + questionPageCounts + 1;
              return;
            } else {
              return;
            }
          });
        } else {
          questionNumber = onlyQuestions.findIndex(function (question) {
            return question.id === item.id;
          }) + 1;
        }
      }
      return questionNumber;
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$props$configOpt2 = this.props.configOptions,
        enablePageManager = _this$props$configOpt2.enablePageManager,
        enableConditionalQuestions = _this$props$configOpt2.enableConditionalQuestions;
      var activePageId = this.state.pages.length > 0 && this.state.pages[this.state.activePageIndex] ? this.state.pages[this.state.activePageIndex].key : this.state.pages[0].key;
      var allQuestions = this.props.questions.flat();
      var onlyQuestions = allQuestions.filter(function (x) {
        return isContentOnlyQuestionType(x) === false;
      });
      var questionsToDisplay = enablePageManager ? allQuestions.filter(function (x) {
        return x.pageId === activePageId;
      }) : allQuestions;
      var drawerOpen = !!this.state.edit; // we hide inline edits if the drawer is open so it won't look weird
      var existingQuestionIds = onlyQuestions.map(function (q) {
        return q.id;
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_modal.Modal, {
        headerText: "Are You Sure?",
        id: "remove-question-modal",
        onCancel: this.onCancelRemove,
        open: this.state.deleteModal.open,
        size: "small"
      }, this.state.activeQuestionHasConditionalRefs && (_p || (_p = /*#__PURE__*/_react.default.createElement("p", null, "This question is referenced by the conditional-display of one or more other questions. If this question is removed, those conditional statements will also be removed from those questions.", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null)))), _p2 || (_p2 = /*#__PURE__*/_react.default.createElement("p", null, "Are you sure you want to remove this question?")), /*#__PURE__*/_react.default.createElement(_modal.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
        onClick: function onClick() {
          return _this7.onClickConfirmRemove(_this7.state.deleteModal.id);
        }
      }, "Confirm"), /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
        "data-dismiss": "modal",
        onClick: this.onCancelRemove
      }, "Cancel"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-border-top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-3 pcty-padding-vertical"
      }, this.props.questionBanksEnabled && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          paddingBottom: '15px'
        }
      }, /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
        fullWidth: true,
        selected: true,
        onClick: this.onShowQuestionBank
      }, "Question Bank")), /*#__PURE__*/_react.default.createElement(_dragNDrop.DragNDrop, {
        id: this.dragFromId
      }, this.getSideBarOptions())), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-9 pcty-border-left pcty-border-fix pcty-padding-vertical pcty-question-builder-drop-area"
      }, /*#__PURE__*/_react.default.createElement(_layout.Row, null, /*#__PURE__*/_react.default.createElement(_layout.Col, {
        className: "pcty-border-bottom pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        id: "create-".concat(this.props.builderType, "-name"),
        label: "".concat((0, _capitalize.default)(this.props.builderTypeName || this.props.builderType), " Name"),
        maxLength: 255,
        onChange: this.handleOnChangeName,
        placeholder: "Please enter a ".concat((0, _capitalize.default)(this.props.builderTypeName || this.props.builderType), " Name"),
        required: true,
        errorMessage: this.props.name.validationState.errorMessage,
        showValidationState: this.props.name.validationState.showValidationState,
        valid: this.props.name.validationState.valid,
        value: this.props.name.value
      })), this.renderTypeOptions()), enablePageManager && /*#__PURE__*/_react.default.createElement(_layout.Row, null, /*#__PURE__*/_react.default.createElement(_layout.Col, {
        className: "pcty-border-bottom pcty-padding-vertical"
      }, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit2.default, {
        id: "question-builder-page-manager",
        pages: this.state.pages,
        activePageIndex: this.state.activePageIndex,
        duplicatePage: function duplicatePage(srcPageId) {
          return _this7.onDuplicatePage(srcPageId);
        },
        deletePage: function deletePage(pageId) {
          return _this7.onDeletePage(pageId);
        },
        setActivePage: function setActivePage(pageId) {
          return _this7.onSetActivePage(pageId);
        },
        addNewPage: function addNewPage() {
          return _this7.onAddNewPage();
        }
      }))), /*#__PURE__*/_react.default.createElement(_layout.Row, null, /*#__PURE__*/_react.default.createElement(_layout.Col, {
        className: "pcty-padding-top"
      }, /*#__PURE__*/_react.default.createElement(_dragNDrop.DragNDrop, {
        dropArea: true,
        id: this.dragTargetId,
        key: "qb-col-dnd-key",
        placeholder: "Drag and drop your questions here.",
        renderPlaceholder: function renderPlaceholder() {
          return _this7.renderPlaceholder();
        }
      }, questionsToDisplay.length ? questionsToDisplay.map(function (item, index) {
        return renderBuilderItem(_this7.props.builderType, _this7.props.configOptions, item, item.id === _this7.state.activeQuestionId && !drawerOpen, _this7.onSetActiveQuestion, _this7.onClickCopy, _this7.onClickEdit, _this7.onClickRemove, _this7.onClickRequired, _this7.onClickHasOtherField, _this7.props.onGetSingleManageVideoToken, _this7.onVideoDoneHandler, _this7.getQuestionNumber(item, onlyQuestions), _this7.onQuestionUpdated, _this7.props.videoStudioEnabled, _this7.props.questionCommentsEnabled);
      }) : null))))), /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
        builderType: this.props.builderType,
        drawerContext: this.state.drawerContext,
        activeTab: this.state.activeDrawerTab,
        edit: this.state.edit,
        id: "".concat(this.props.id, "-question"),
        number: this.state.editQuestionNumber,
        questions: allQuestions,
        enableConditionalQuestions: enableConditionalQuestions,
        onClickCancelEditing: this.onClickCancelEditing,
        onClickConfirmRemove: this.onClickConfirmRemove,
        onClickSaveEditing: this.onClickSaveEditing,
        onGetSingleManageVideoToken: this.props.onGetSingleManageVideoToken,
        videoStudioEnabled: this.props.videoStudioEnabled,
        questionCommentsEnabled: this.props.questionCommentsEnabled
      }), this.props.questionBanksEnabled && this.props.questionBankQuestions.length > 0 && /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderQuestionBank.default, {
        open: this.state.showQuestionBank,
        onAddQuestions: this.onAddQuestionsFromQuestionBank,
        onCancel: this.onCancelQuestionBank,
        questionBankQuestions: this.props.questionBankQuestions,
        existingQuestionIds: existingQuestionIds
      }));
    }
  }, {
    key: "onDuplicatePage",
    value: function onDuplicatePage(srcPageId) {
      var _this8 = this;
      var pages = (0, _toConsumableArray2.default)(this.state.pages);
      var activePageIndex = this.state.activePageIndex + 1;

      // insert the new item to the right of the selected one and make it active
      var newPageId = _uuid.default.v4();
      pages.splice(activePageIndex, 0, {
        key: newPageId
      });
      this.setState({
        pages: pages,
        activePageIndex: activePageIndex
      });
      var questions = (0, _toConsumableArray2.default)(this.props.questions.flat());
      var srcPageQuestions = questions.filter(function (x) {
        return x.pageId === srcPageId;
      });

      // if the src-page has questions, copy them and then insert the entire set AFTER the last question on the src-page
      // this is because because pages are derived from the specific order of the questions and their page-ids
      if (srcPageQuestions.length > 0) {
        var srcPageLastQuestion = srcPageQuestions[srcPageQuestions.length - 1];
        var srcPageLastQuestionIndex = questions.findIndex(function (question) {
          return question.id === srcPageLastQuestion.id;
        });
        var destPageQuestions = [];
        srcPageQuestions.map(function (item) {
          var copiedItem = _this8.copyQuestion(item, newPageId);
          destPageQuestions.push(copiedItem);
        });

        // splice the new questions after the last question on the src-page
        questions = [].concat((0, _toConsumableArray2.default)(questions.slice(0, srcPageLastQuestionIndex)), destPageQuestions, (0, _toConsumableArray2.default)(questions.slice(srcPageLastQuestionIndex)));
      }
      this.handleOnChangeQuestionsWithPages(questions);
    }
  }, {
    key: "copyQuestion",
    value: function copyQuestion(question) {
      var pageId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (!question) return question;
      var copiedItem = _objectSpread({}, question);
      copiedItem.id = _uuid.default.v4();
      copiedItem.key = _uuid.default.v4();
      copiedItem.fromQuestionBank = false;
      copiedItem.visibleIf = ''; // clear out conditional refs!
      // if a pageId has been explicitely set, use it (copy page!)
      if (pageId) copiedItem.pageId = pageId;

      // reassign option's ids
      if (copiedItem.options && copiedItem.options.length > 0) {
        var options = copiedItem.options.map(function (opt) {
          var newOpt = _objectSpread({}, opt);
          newOpt.id = _uuid.default.v4();
          return newOpt;
        });
        copiedItem.options = options;
      }

      // reassign otherQuestion ids
      if (copiedItem.otherQuestion) {
        var otherQuestion = _objectSpread({}, copiedItem.otherQuestion);
        otherQuestion.id = _uuid.default.v4();
        copiedItem.otherQuestion = otherQuestion;
      }
      return copiedItem;
    }
  }, {
    key: "onDeletePage",
    value: function onDeletePage(pageId) {
      var _this9 = this;
      var pages = (0, _toConsumableArray2.default)(this.state.pages);
      var activeIndex = pages.findIndex(function (x) {
        return x.key === pageId;
      });
      if (activeIndex >= 0) {
        pages.splice(activeIndex, 1);

        // get a list of all the questions on the page we're deleteing
        var questionsToDelete = this.props.questions.flat().filter(function (x) {
          return x.pageId === pageId;
        });
        var allQuestions = (0, _toConsumableArray2.default)(this.props.questions.flat());

        // clear out the conditional statements for ALL questions referencing this id!
        questionsToDelete.map(function (questionToDelete) {
          if (_this9.questionHasConditionalReferences(questionToDelete.id)) {
            // cannot clear out just the invalid clause because it may invalid the conditional logic!
            allQuestions.map(function (question, index) {
              if (question.visibleIf && question.visibleIf.length > 0 && question.visibleIf.indexOf(questionToDelete.id) > -1) {
                question.visibleIf = '';
                allQuestions = (0, _replaceAt.default)(allQuestions, index, question);
              }
            });
          }
        });

        // delete all the questions with this pageId via filtering
        this.handleOnChangeQuestionsWithPages(allQuestions.filter(function (x) {
          return x.pageId !== pageId;
        }));

        // set the new active page to whichever one takes its spot (or the prev one if needbe)
        var activePageIndex = activeIndex >= pages.length ? activeIndex - 1 : activeIndex;
        this.setState({
          pages: pages,
          activePageIndex: activePageIndex
        });
      }
    }
  }, {
    key: "onSetActivePage",
    value: function onSetActivePage(pageId) {
      // find the page the selected and set it to be the active one
      var activePageIndex = this.state.pages.findIndex(function (x) {
        return x.key === pageId;
      });
      if (activePageIndex >= 0) {
        // don't forget to clear the activeQuestionId when changing pages!
        this.setState({
          activePageIndex: activePageIndex,
          activeQuestionId: null
        });
      }
    }
  }, {
    key: "onAddNewPage",
    value: function onAddNewPage() {
      var pages = (0, _toConsumableArray2.default)(this.state.pages);
      var newPageId = _uuid.default.v4();

      // add the new page to the end of the stack
      pages.push({
        key: newPageId
      });
      var activePageIndex = pages.length - 1;
      this.setState({
        pages: pages,
        activePageIndex: activePageIndex
      });
    }
  }, {
    key: "renderTypeOptions",
    value: function renderTypeOptions() {
      var _this10 = this;
      var validationState = this.props.categoryType.validationState;
      var classes = !validationState.valid && validationState.showValidationState ? 'render-type-options pcty-error' : 'render-type-options';
      if ((0, _isNotNullOrEmpty.default)(this.props.categoryTypeOptions)) {
        var options = this.props.categoryTypeOptions.map(function (x) {
          return {
            value: x.value,
            label: x.text
          };
        });
        var selectedValue = options.find(function (x) {
          return x.value === _this10.state.categoryType.value;
        });
        return /*#__PURE__*/_react.default.createElement(_layout.Col, {
          className: "pcty-border-bottom pcty-padding-bottom"
        }, /*#__PURE__*/_react.default.createElement(_inputSelect.SelectStatic, {
          automationId: "create-".concat(this.props.builderType, "-type"),
          id: "create-".concat(this.props.builderType, "-type"),
          className: classes,
          label: "".concat((0, _capitalize.default)(this.props.builderTypeName || this.props.builderType), " Category"),
          onChange: this.handleOnChangeCategoryType,
          options: options,
          required: this.props.categoryTypeRequired,
          placeholder: "Select...",
          errorMessage: this.props.categoryType.validationState.errorMessage,
          showValidationState: this.props.categoryTypeRequired && this.props.categoryType.validationState.showValidationState,
          valid: !this.props.categoryTypeRequired || this.props.categoryType.validationState.valid,
          value: selectedValue
        }));
      }
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12 pcty-type-centeralign pcty-padding-top pcty-question-builder-zero-state-container"
      }, /*#__PURE__*/_react.default.createElement(_zeroState.ZeroState, {
        automationId: "qb-zero-state",
        imageCss: {
          width: 'unset !important'
        },
        imageUrl: _quizBuilderDrag.default,
        key: "qb-zero-state",
        message: "To build your ".concat((0, _capitalize.default)(this.props.builderTypeName || this.props.builderType), ", drag content from the Toolbox on the left and drop it here")
      })));
    }
  }]);
  return PctyQuestionBuilder;
}(_react.Component); // end of PctyQuestionBuilder class!!
var renderBuilderItem = function renderBuilderItem(builderType, configOptions, item, isActiveQuestion, onSetActiveQuestion, onClickCopy, onClickEdit, onClickRemove, onClickRequired, onClickHasOtherField, onGetSingleManageVideoToken, onVideoDoneHandler, number, _onQuestionUpdated, videoStudioEnabled, questionCommentsEnabled) {
  var isEditable = configOptions.enableInlineEditing && isActiveQuestion && !item.fromQuestionBank;
  var allowConditionalQuestions = configOptions.enableConditionalQuestions && isActiveQuestion;
  var getQuestion = function getQuestion(builderType, item, _onGetSingleManageVideoToken, _onVideoDoneHandler, number) {
    switch (item.typeId) {
      default:
        return null;
      case _questionBuilder.QUESTION_TYPE.checkbox:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder2.default, {
          hint: item.hint,
          id: item.id + '-checkbox',
          builderType: builderType,
          displayFormat: item.displayFormat || 1,
          knockout: item.knockout,
          knockoutText: _PctyQuestionBuilder15.KNOCKOUT_TEXT[builderType],
          number: number,
          options: item.options,
          otherQuestion: item.otherQuestion,
          question: item.question,
          required: item.answerRequired,
          editable: isEditable,
          scenario: item.scenario,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          selectedIndexes: (0, _findIndexes.default)(item.options, function (x) {
            return (0, _lodash.default)(item.answers, function (z) {
              return z.optionId === x.id;
            }) >= 0;
          })
        });
      case _questionBuilder.QUESTION_TYPE.multipleChoice:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder3.default, {
          displayFormat: item.displayFormat || 1,
          hint: item.hint,
          id: item.id + '-multiple-choice',
          builderType: builderType,
          knockout: item.knockout,
          knockoutText: _PctyQuestionBuilder15.KNOCKOUT_TEXT[builderType],
          number: number,
          options: item.options,
          otherQuestion: item.otherQuestion,
          question: item.question,
          scenario: item.scenario,
          required: item.answerRequired,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          selectedIndex: item.answers && item.answers.length > 0 ? (0, _lodash.default)(item.options, function (x) {
            return x.id === item.answers[0].optionId;
          }) : -1
        });
      case _questionBuilder.QUESTION_TYPE.trueFalse:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder4.default, {
          hint: item.hint,
          id: item.id + '-true-false',
          builderType: builderType,
          knockout: item.knockout,
          knockoutText: _PctyQuestionBuilder15.KNOCKOUT_TEXT[builderType],
          number: number,
          question: item.question,
          required: item.answerRequired,
          scenario: item.scenario,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          selectedIndex: item.answers && item.answers.length > 0 ? (0, _lodash.default)(item.options, function (x) {
            return x.id === item.answers[0].optionId;
          }) : -1
        });
      case _questionBuilder.QUESTION_TYPE.stackRank:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder5.default, {
          builderType: builderType,
          hint: item.hint,
          id: item.id + '-stack-rank',
          knockout: item.knockout,
          knockoutText: _PctyQuestionBuilder15.KNOCKOUT_TEXT[builderType],
          number: number,
          options: item.options,
          optionsCorrectOrder: item.answers,
          question: item.question,
          required: item.answerRequired,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          scenario: item.scenario
        });
      case _questionBuilder.QUESTION_TYPE.title:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder6.default, {
          id: item.id + '-section-title',
          builderType: builderType,
          includeSectionHeading: item.includeSectionHeading,
          content: item.title,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          }
        });
      case _questionBuilder.QUESTION_TYPE.paragraph:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder7.default, {
          id: item.id + '-section-paragraph',
          builderType: builderType,
          content: item.content,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          }
        });
      case _questionBuilder.QUESTION_TYPE.video:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder8.default, {
          id: item.id + '-video',
          builderType: builderType,
          content: item.title,
          videoId: item.videoId,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          onGetSingleManageVideoToken: function onGetSingleManageVideoToken(videoId) {
            return _onGetSingleManageVideoToken(videoId);
          },
          onVideoDoneHandler: function onVideoDoneHandler(videoEvent) {
            return _onVideoDoneHandler(item, videoEvent);
          },
          videoStudioEnabled: videoStudioEnabled
        });
      case _questionBuilder.QUESTION_TYPE.textField:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder9.default, {
          id: item.id + '-text-field',
          builderType: builderType,
          number: number,
          multiLine: item.multiLine,
          placeholder: item.questionPlaceholder,
          question: item.question,
          required: item.answerRequired,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          }
        });
      case _questionBuilder.QUESTION_TYPE.starRating:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder10.default, {
          starCount: item.starCount,
          builderType: builderType,
          id: item.id + '-star-rating',
          number: number,
          question: item.question,
          required: item.answerRequired,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          value: item.value,
          questionCommentsEnabled: questionCommentsEnabled,
          allowComments: item.allowComments,
          commentsPlaceholder: item.commentsPlaceholder
        });
      case _questionBuilder.QUESTION_TYPE.ratingScale:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder11.default, {
          id: item.id + '-rating-scale',
          builderType: builderType,
          options: item.options,
          maximumRateLabel: item.maximumRateLabel,
          minimumRateLabel: item.minimumRateLabel,
          number: number,
          question: item.question,
          required: item.answerRequired,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          value: item.value,
          questionCommentsEnabled: questionCommentsEnabled,
          allowComments: item.allowComments,
          commentsPlaceholder: item.commentsPlaceholder
        });
      case _questionBuilder.QUESTION_TYPE.multipleText:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder12.default, {
          hint: item.hint,
          id: item.id + '-multiple-text',
          builderType: builderType,
          knockout: item.knockout,
          knockoutText: _PctyQuestionBuilder15.KNOCKOUT_TEXT[builderType],
          number: number,
          options: item.options,
          question: item.question,
          required: item.answerRequired,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          scenario: item.scenario
        });
      case _questionBuilder.QUESTION_TYPE.constantSum:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder13.default, {
          enforceTargetSum: item.enforceTargetSum,
          hint: item.hint,
          id: item.id + '-constant-sum',
          builderType: builderType,
          knockout: item.knockout,
          knockoutText: _PctyQuestionBuilder15.KNOCKOUT_TEXT[builderType],
          maximumValue: item.maximumValue,
          minimumValue: item.minimumValue,
          number: number,
          options: item.options,
          question: item.question,
          required: item.answerRequired,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          scenario: item.scenario,
          targetSumValue: item.targetSumValue
        });
      case _questionBuilder.QUESTION_TYPE.dropdownList:
        return /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilder14.default, {
          displayFormat: item.displayFormat || 1,
          hint: item.hint,
          id: item.id + '-dropdown-list',
          builderType: builderType,
          placeholder: item.questionPlaceholder,
          knockout: item.knockout,
          knockoutText: _PctyQuestionBuilder15.KNOCKOUT_TEXT[builderType],
          number: number,
          options: item.options,
          otherQuestion: item.otherQuestion,
          question: item.question,
          required: item.answerRequired,
          editable: isEditable,
          onQuestionUpdated: function onQuestionUpdated(updates) {
            return _onQuestionUpdated(item.id, updates);
          },
          scenario: item.scenario,
          selectedIndex: item.answers && item.answers.length > 0 ? (0, _lodash.default)(item.options, function (x) {
            return x.id === item.answers[0].optionId;
          }) : -1
        });
    }
  };

  // clear out any buttons events that aren't allowed (which will also hide them)
  if (builderType === _PctyQuestionBuilder15.BUILDER_TYPE.quiz || !isHasOtherOptionQuestionType(item)) onClickHasOtherField = undefined;
  if (builderType === _PctyQuestionBuilder15.BUILDER_TYPE.quiz || isContentOnlyQuestionType(item)) onClickRequired = undefined;
  var id = item.id;
  var itemKey = item.key || item.id;
  var isInvalidQuestion = item.validationState && !item.validationState.valid ? true : false;
  var qbNoEditingText = "Question Bank questions can't be edited to maintain tracking integrity.";
  var otherClasses = '';
  if (isActiveQuestion) {
    otherClasses = 'active pcty-undraggable citron-undraggable';
  } else if (isInvalidQuestion) {
    otherClasses = 'invalid';
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: itemKey
  }, /*#__PURE__*/_react.default.createElement(_dragNDrop.DragNDrop.DroppedItem, {
    className: "pcty-top pcty-dropped-question ".concat(otherClasses),
    id: id,
    key: itemKey,
    onClick: function onClick() {
      return onSetActiveQuestion(item);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12 pcty-padding-left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row-float-fill pcty-flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'pcty-col-fluid pcty-padding-right pcty-compact-padding-left pcty-padding-bottom'
  }, item.answerRequired && (_Badge || (_Badge = /*#__PURE__*/_react.default.createElement(_badge.Badge, {
    className: "question-badges",
    size: "small",
    value: "Required"
  }))), item.fromQuestionBank && (_Badge2 || (_Badge2 = /*#__PURE__*/_react.default.createElement(_badge.Badge, {
    className: "question-badges",
    size: "small",
    value: "Question Bank"
  }))), item.visibleIf && item.visibleIf.length > 0 && (_Badge3 || (_Badge3 = /*#__PURE__*/_react.default.createElement(_badge.Badge, {
    className: "question-badges",
    color: "green",
    size: "small",
    value: "Conditional"
  })))), isActiveQuestion && /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-padding-right pcty-align-right",
    style: {
      marginTop: '-7px'
    }
  }, onClickEdit && !item.fromQuestionBank && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
    css: {
      maxWidth: 16,
      marginRight: 15
    },
    onClick: function onClick() {
      return onClickEdit(item, number);
    }
  }, _Icon || (_Icon = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "pencil",
    title: "Edit"
  }))), onClickRequired && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
    css: {
      maxWidth: 16,
      marginRight: 15
    },
    onClick: function onClick() {
      return onClickRequired(item);
    }
  }, _Icon2 || (_Icon2 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "required",
    title: "Required"
  }))), onClickHasOtherField && !item.fromQuestionBank && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
    css: {
      maxWidth: 16,
      marginRight: 15
    },
    onClick: function onClick() {
      return onClickHasOtherField(item);
    }
  }, _Icon3 || (_Icon3 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "check",
    title: "Has Other?"
  }))), allowConditionalQuestions && onClickEdit && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
    css: {
      maxWidth: 16,
      marginRight: 15
    },
    onClick: function onClick() {
      return onClickEdit(item, number, 'conditional');
    }
  }, _Icon4 || (_Icon4 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chart-flow",
    title: "Conditional"
  }))), onClickCopy && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
    css: {
      maxWidth: 16,
      marginRight: 15
    },
    onClick: function onClick() {
      return onClickCopy(item);
    }
  }, _Icon5 || (_Icon5 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "copy",
    title: "Duplicate"
  }))), onClickRemove && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
    css: {
      maxWidth: 16,
      marginRight: 15
    },
    onClick: function onClick() {
      return onClickRemove(item);
    }
  }, _Icon6 || (_Icon6 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "trash",
    title: "Delete"
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12 pcty-padding-left"
  }, isActiveQuestion && item.fromQuestionBank && /*#__PURE__*/_react.default.createElement(_callout.Callout, {
    automationId: 'qb-inset-banner-hint-' + item.id,
    id: 'qb-inset-banner-hint-' + item.id
  }, /*#__PURE__*/_react.default.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, qbNoEditingText)), getQuestion(builderType, item, onGetSingleManageVideoToken, onVideoDoneHandler, number)))))), isInvalidQuestion && (_div || (_div = /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-input-footnote invalid-question"
  }, "This question contains one or more errors."))));
};
var transformDroppedItem = function transformDroppedItem(_ref2) {
  var id = _ref2.id,
    required = _ref2.required,
    page = _ref2.page;
  var typeId = parseInt(id);
  var pageId = page ? page.key || _uuid.default.v4() : _uuid.default.v4();
  var item = (0, _PctyQuestionBuilder.getDefaultQuestionSettings)(typeId, required, pageId);
  return item;
};
var isContentOnlyQuestionType = function isContentOnlyQuestionType(item) {
  return item.typeId === _questionBuilder.QUESTION_TYPE.paragraph || item.typeId === _questionBuilder.QUESTION_TYPE.title || item.typeId === _questionBuilder.QUESTION_TYPE.video;
};
var isHasOtherOptionQuestionType = function isHasOtherOptionQuestionType(item) {
  return item.typeId === _questionBuilder.QUESTION_TYPE.checkbox || item.typeId === _questionBuilder.QUESTION_TYPE.multipleChoice || item.typeId === _questionBuilder.QUESTION_TYPE.dropdownList;
};
var getPages = function getPages(questions, enablePageManager) {
  var key = _PctyQuestionBuilder15.DEFAULT_PAGE_ID_KEY;
  if (!enablePageManager) return [{
    key: key
  }];
  if (questions && questions.length > 0 && (0, _isNotNullOrEmpty.default)(questions[0].pageId)) {
    var pageObjs = (0, _lodash3.default)(questions, 'pageId');
    if (pageObjs) {
      return Object.keys(pageObjs).map(function (pkey) {
        return {
          key: pkey
        };
      });
    }
    return [{
      key: key
    }];
  }
  return [{
    key: key
  }];
};
PctyQuestionBuilder.propTypes = {
  /** The id of the component */
  id: _propTypes.default.string.isRequired,
  /** The type of questions you'll be building. */
  builderType: _propTypes.default.oneOf([_PctyQuestionBuilder15.BUILDER_TYPE.quiz, _PctyQuestionBuilder15.BUILDER_TYPE.survey]).isRequired,
  /** The name for the type of questions you'll be building. */
  builderTypeName: _propTypes.default.string,
  /** The data for the questions. */
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    typeId: _propTypes.default.number.isRequired,
    scenario: _propTypes.default.string,
    question: _propTypes.default.string.isRequired,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      value: _propTypes.default.string.isRequired
    })),
    answers: _propTypes.default.arrayOf(_propTypes.default.shape({
      optionId: _propTypes.default.string.isRequired
    })),
    knockout: _propTypes.default.bool,
    hint: _propTypes.default.string,
    correctFeedback: _propTypes.default.string,
    incorrectFeedback: _propTypes.default.string
  })),
  /** The options to configure the builder */
  configOptions: _propTypes.default.shape({
    questionsPerPage: _propTypes.default.number,
    setDefaultRequired: _propTypes.default.bool,
    enablePageManager: _propTypes.default.bool,
    enableInlineEditing: _propTypes.default.bool,
    enableConditionalQuestions: _propTypes.default.bool
  }),
  /** The object that contains the name value and the current validation state for this field. */
  name: _propTypes.default.shape({
    value: _propTypes.default.string,
    validationState: _propTypes.default.shape({
      valid: _propTypes.default.bool,
      errorMessage: _propTypes.default.string,
      showValidationState: _propTypes.default.bool
    })
  }),
  /** Callback function to get the updated name. */
  onChangeName: _propTypes.default.func.isRequired,
  /** Callback function to get the updated questions. */
  onChangeQuestions: _propTypes.default.func.isRequired,
  /** Callback function to get the updated category type option. */
  onChangeCategoryType: _propTypes.default.func,
  /** Callback function to get notified each time the user drops a new question. */
  onDrop: _propTypes.default.func.isRequired,
  /** Callback function for when a Video edit/manage token is requested. */
  onGetSingleManageVideoToken: _propTypes.default.func,
  /** The object that contains the categoryTypeOptions array for this field. */
  categoryTypeOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired,
    selected: _propTypes.default.bool
  })),
  /** The object that contains the categoryType object and the current validation state for this field. */
  categoryType: _propTypes.default.shape({
    selected: _propTypes.default.shape({
      text: _propTypes.default.string,
      value: _propTypes.default.string
    }),
    validationState: _propTypes.default.shape({
      valid: _propTypes.default.bool,
      errorMessage: _propTypes.default.string,
      showValidationState: _propTypes.default.bool
    })
  }),
  /** Whether the category/type option selection is required  */
  categoryTypeRequired: _propTypes.default.bool,
  /** Whether the Video Question-type is displayed  */
  premiumVideoEnabled: _propTypes.default.bool,
  /** Whether add video from Video Studio is enabled */
  videoStudioEnabled: _propTypes.default.bool,
  /** Whether the user is allowed to add comments to questions */
  questionCommentsEnabled: _propTypes.default.bool,
  /** Whether the user is allowed to add questions from the Question Bank */
  questionBanksEnabled: _propTypes.default.bool,
  /** The object that contains the categoryTypeOptions array for this field. */
  questionBankQuestions: _propTypes.default.arrayOf(_propTypes.default.any)
};
PctyQuestionBuilder.defaultProps = {
  questions: [],
  onDrop: function onDrop() {},
  onChangeCategoryType: function onChangeCategoryType() {},
  configOptions: {
    questionsPerPage: 0,
    enablePageManager: false,
    enableInlineEditing: false,
    enableConditionalQuestions: false
  },
  categoryTypeOptions: [],
  categoryTypeRequired: false,
  premiumVideoEnabled: false,
  videoStudioEnabled: false,
  questionCommentsEnabled: false,
  questionBanksEnabled: false
};
var _default = exports.default = PctyQuestionBuilder;